import { SimpleOauth2User } from 'src/app/cc-api/models';
import { settingsSubMenuItems } from 'src/app/constants/sidebar';
import { NbMenuItem } from '@nebular/theme';
import { Subject } from 'rxjs';
import { ROLE_CC_ADMIN } from '../constants/permissions';
import { Injectable } from '@angular/core';
import { UserAuthoritiesService } from './user-authorities.service';
import { UserSidebar } from '../components/sidebar-v2/sidebar.type';

const sidebarDataMap = {
  SETTINGS: settingsSubMenuItems,
};

@Injectable({
  providedIn: 'root',
})
export class UserService {
  userLoaded: boolean = false;
  _user: SimpleOauth2User;
  isAdmin: boolean = false;
  userSidebar: UserSidebar = {
    ARTIFACTS: {},
    ENVIRONMENT: {},
    SETTINGS: {},
  };
  userAuthorities: {} = {};

  userObserver: Subject<boolean> = new Subject();

  constructor(private userAuthoritiesService: UserAuthoritiesService) {
    this.userObserver.subscribe((value) => {
      this.userLoaded = value;
    });
  }

  setUser(user: SimpleOauth2User) {
    this._user = user;
    this.formUserAuthoritiesObject();
    this.setUserIfAdmin();
    this.userAuthoritiesService.initAuthorities(user);
    this.userObserver.next(true);
  }
  protected setUserIfAdmin() {
    this.isAdmin = this.userAuthorities[ROLE_CC_ADMIN];
  }
  protected formUserAuthoritiesObject() {
    this._user.authorities?.forEach((authority) => {
      this.userAuthorities[authority.authority] = true;
    });
  }

  get user() {
    return this._user;
  }

  protected setUserSidebar(category: string) {
    if (!this.userSidebar[category]) {
      return;
    }
    const userSidebarSubMenus = this.userSidebar[category];

    let hasSomePermissions;
    Object.entries(sidebarDataMap[category])?.forEach(([key, value]) => {
      if (!value?.['checkPermission']) {
        userSidebarSubMenus[key] = true;
      } else {
        hasSomePermissions = value?.['permissions']?.some(
          (role) => this.userAuthorities[role],
        );
        if (hasSomePermissions) {
          userSidebarSubMenus[key] = true;
        }
      }
    });

    this.userSidebar[category] = userSidebarSubMenus;
  }

  protected getSubMenuItemsForNonAdmin = (
    category: string,
    baseUrl: string,
  ) => {
    this.setUserSidebar(category);
    return this.getRoutesInfo(category, baseUrl, this.userSidebar[category]);
  };

  protected getRoutesInfo(
    category: string,
    baseUrl: string,
    userSidebarSubMenus,
  ) {
    if (!this.userSidebar[category]) {
      return [];
    }

    let routes = [];
    Object.keys(userSidebarSubMenus)?.forEach((item) => {
      const { routeInfo } = sidebarDataMap?.[category]?.[item] || {};
      routes.push({
        ...routeInfo,
        link: `${baseUrl}/${routeInfo?.link}`,
      });
    });
    return routes;
  }

  getSidebarSubMenuItemsOf(
    category: string,
    baseUrl: string,
  ): Array<NbMenuItem> {
    // if (this.isAdmin) {
    //   return this.getRoutesInfo(category, baseUrl, sidebarDataMap[category]);
    // }
    // return this.getSubMenuItemsForNonAdmin(category, baseUrl);
    return this.getRoutesInfo(category, baseUrl, sidebarDataMap[category]);
  }

  hasSomeroles(neededRoles) {
    if (this.isAdmin) {
      return true;
    }
    return neededRoles.some((role) => {
      return this.userAuthorities[role];
    });
  }

  getLoggedInUserName() {
    return this._user?.name;
  }

  resetUserData() {
    this.userLoaded = false;
    this._user = undefined;
    this.isAdmin = false;
    this.userAuthorities = {};
    this.userSidebar = {
      ARTIFACTS: {},
      ENVIRONMENT: {},
      SETTINGS: {},
    };
  }
  isUserAdmin() {
    return this.isAdmin;
  }
}
